export default __webpack_public_path__ + "static/media/icon-monTableau-select.902c0065.svg";